<div id="investmentStrategyModal" class="flex flex-col w-full h-full">
     <header class="flex items-center flex-none p-10 border-b border-solid md:p-20 border-gray-lighter">
          <div class="flex items-center flex-none">
               <span class="flex items-center justify-center p-10 rounded-full w-72 h-72 bg-gray-lightest mr-5">
                    <img class="w-full h-auto" src="./assets/images/logos/alphastar-icon.svg">
               </span>
          </div>
          <div class="flex flex-col flex-wrap p-10">
               <h2 class="flex  ml-10 text-lg font-bold">Release Notes</h2>
          </div>
          <button mat-button class="m-10 ml-auto icon-button is-primary is-inverted" tabindex="-1" type="button"
               (click)="closeRequest()" mat-dialog-close>
               <i class="material-icons">close</i>
          </button>
     </header>
     <div class="flex flex-col flex-grow h-full overflow-y-scroll">
          <section class="flex flex-col p-10 overflow-auto md:p-20 dialog-content gap-y-20">

               @for (rn of releaseNotes; track rn) {
               <div class="flex flex-col gap-y-10 text-sm border-b border-solid pb-20 border-gray-lighter">
                    <div class="flex flex-col flex-wrap cursor-pointer" (click)="rn.Expanded = !rn.Expanded">
                         <h2 class="flex text-base font-bold text-blue-darker" [innerHTML]="rn.Title"></h2>
                         <h3 class="flex italic">Release Date: {{rn.ReleaseDate | date: 'longDate'}}</h3>
                    </div>
                    @if (rn.Expanded) {
                         <div class="flex flex-col ml-10 gap-y-10">
                              <div class="flex flex-wrap" [innerHTML]="rn.Description"></div>

                              <div class="font-bold text-blue-darker">
                                   What's New?
                              </div>
                              <div class="flex">                              
                                   <span [innerHTML]="rn.WhatsNew"></span>
                              </div>

                              @for (p of rn.New; track p) {                        
                                   <div class="flex flex-row gap-x-10 items-center">
                                        <i class="material-icons" style="font-size: 7px;">fiber_manual_record</i>
                                        <span [innerHTML]="p.Point"></span>
                                   </div>
                                   @if (p.Description) {
                                        <div class="flex ml-10">                              
                                             <span [innerHTML]="p.Description"></span>
                                        </div>
                                   }                                   
                                   @for (sp of p.SubPoints; track sp) {
                                        <div class="flex flex-row gap-x-10 items-center ml-20">
                                             <i class="material-icons" style="font-size: 7px;">radio_button_unchecked</i>
                                             <span [innerHTML]="sp"></span>
                                        </div>
                                   }
                              }

                              <div class="font-bold text-blue-darker">
                                   Key Benefits
                              </div>
                              @for (p of rn.Benefits; track p) {
                                   <div class="flex flex-row gap-x-10 items-center">
                                        <i class="material-icons" style="font-size: 7px;">fiber_manual_record</i>
                                        <span [innerHTML]="p.Point"></span>
                                   </div>
                                   @if (p.Description) {
                                        <div class="flex ml-10">                              
                                             <span [innerHTML]="p.Description"></span>
                                        </div>
                                   }
                                   @for (sp of p.SubPoints; track sp) {
                                        <div class="flex flex-row gap-x-10 items-center ml-20">
                                             <i class="material-icons" style="font-size: 7px;">radio_button_unchecked</i>
                                             <span [innerHTML]="sp"></span>
                                        </div>
                                   }
                              }

                         <div class="font-bold text-blue-darker">
                              How to Access
                         </div>
                         @for (p of rn.Access; track p) {
                              <div class="flex flex-row gap-x-10 items-center">
                                   <i class="material-icons" style="font-size: 7px;">fiber_manual_record</i>
                                   <span [innerHTML]="p.Point"></span>
                              </div>
                              @for (sp of p.SubPoints; track sp) {
                                   <div class="flex flex-row gap-x-10 items-center ml-20">
                                        <i class="material-icons" style="font-size: 7px;">radio_button_unchecked</i>
                                         <span [innerHTML]="sp"></span>
                                   </div>
                              }
                         }
                    </div>
                    }
                   
               </div>
               }

          </section>
     </div>
</div>